import { urlEncodeB64 } from "./urlEncodeB64";

export function getRandomBase64Code(bitLength: number): string {
    const array = crypto.getRandomValues(new Uint8Array(bitLength));
    const randomString = String.fromCharCode.apply(null, Array.from(array));
    const base64 = btoa(randomString);
    return urlEncodeB64(base64);
}
